// extracted by mini-css-extract-plugin
export default {"container":"video_container__JYYGG","arrowPlay":"video_arrowPlay__3kPpE"};